import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SimpleVoiceRecorder from "../../components/ui/SimpleVoiceRecorder_RTC";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function Audio() {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const [isRecording, setIsRecording] = useState(false);
  const [audioData, setAudioData] = useState(null); // Данные аудио с сервера или blob
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recordingComplete, setRecordingComplete] = useState(false);
  const [microphoneError, setMicrophoneError] = useState(false);
  const [resetCount, setResetCount] = useState(0);

  const handleResetRecording = () => {
    const newResetCount = resetCount + 1;
    setResetCount(newResetCount);
    console.log(`💀 ЯДЕРНЫЙ СБРОС #${newResetCount} в Audio.jsx`);

    setRecordingComplete(false);
    setIsRecording(false);
    setAudioData(null);

    console.log(`✅ ЯДЕРНЫЙ СБРОС #${newResetCount} ЗАВЕРШЕН в Audio.jsx`);
  };

  const handleRecordingComplete = (result) => {
    const attempt = resetCount + 1;
    console.log(
      `🎯 ПОПЫТКА #${attempt} в Audio.jsx - ПОЛУЧИЛИ РЕЗУЛЬТАТ:`,
      result
    );

    if (!result) {
      console.error(
        `❌ ПОПЫТКА #${attempt} ПРОВАЛЕНА в Audio.jsx - НЕТ РЕЗУЛЬТАТА`
      );
      return;
    }

    // Если это объект с сервера
    if (result.audioId) {
      console.log(
        `🎉 ПОПЫТКА #${attempt} УСПЕШНА в Audio.jsx - АУДИО НА СЕРВЕРЕ!`
      );

      setTimeout(
        () => {
          setAudioData({
            audioId: result.audioId,
            size: result.size,
            duration: result.duration,
          });
          setRecordingComplete(true);
          console.log(`✅ Состояния установлены для попытки #${attempt}`);
        },
        attempt <= 2 ? 150 : 300
      );
    }
    // Если это fallback blob
    else if (result.size && result.size >= 1000) {
      console.log(
        `⚠️ ПОПЫТКА #${attempt} в Audio.jsx - FALLBACK BLOB`,
        result.size,
        "байт"
      );

      setTimeout(
        () => {
          setAudioData({
            blob: result,
            size: result.size,
            duration: 0,
          });
          setRecordingComplete(true);
        },
        attempt <= 2 ? 150 : 300
      );
    } else {
      console.error(
        `❌ ПОПЫТКА #${attempt} ПРОВАЛЕНА в Audio.jsx - ПЛОХИЕ ДАННЫЕ:`,
        result
      );
    }
  };

  const handleSave = async () => {
    if (!audioData) return;

    try {
      setIsSubmitting(true);

      // Если аудио на сервере (temporary storage) - сохраняем в профиль
      if (audioData.audioId) {
        console.log("💾 Сохранение аудио в профиль, ID:", audioData.audioId);

        await axiosPrivate.post("/audio-message/save-to-profile", {
          audioId: audioData.audioId,
        });

        console.log("✅ Аудио сохранено в профиль");
        navigate(-1);
      }
      // Если локальный blob - загружаем через старый эндпоинт (fallback)
      else if (audioData.blob) {
        console.log("⚠️ Fallback: загрузка blob через /users/updateAudio");

        const formData = new FormData();
        formData.append("file", audioData.blob);
        formData.append("duration", audioData.duration || 0);

        const bars = Array(46).fill(7);
        formData.append("audioMessageBars", JSON.stringify(bars));

        const response = await axiosPrivate.put(
          "/users/updateAudio",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("✅ Audio update response:", response.data);
        navigate(-1);
      } else {
        throw new Error("Нет данных аудио для сохранения");
      }
    } catch (error) {
      console.error("❌ Error updating audio:", error);
      alert(
        "Произошла ошибка при сохранении аудио. Пожалуйста, попробуйте еще раз."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-[100vw] flex items-center justify-center flex-col">
      <div className="sticky top-0 left-0 right-0 w-full pt-[26px] pb-[30px] pl-[16px] pr-[16px] flex-row text-[18px] flex justify-between z-50">
        <span className="text-white" onClick={() => navigate(-1)}>
          Отмена
        </span>
        <span
          className={`${isSubmitting ? "opacity-50" : "text-[#A1F69E]"}`}
          onClick={isSubmitting ? undefined : handleSave}
        >
          {isSubmitting ? "Сохранение..." : "Сохранить"}
        </span>
      </div>
      <div className="flex flex-col items-center w-[343px] h-[750px] overflow-y-auto overflow-x-hidden">
        <h1 className="font-raleway font-semibold mt-6 text-white text-[20px]">
          Аудио визитка (30 сек)
        </h1>
        <h1 className="font-raleway font-light mt-2 text-white text-center text-[16px]">
          Расскажите немного о себе другим пользователям. При необходимости
          аудио визитку можно будет перезаписать или удалить
        </h1>

        {microphoneError ? (
          <div className="mt-10 text-center">
            <div className="mb-6 p-4 bg-red-900/20 border border-red-500/30 rounded-lg">
              <p className="font-raleway font-medium text-red-300 text-[16px] mb-2">
                Нет доступа к микрофону
              </p>
              <p className="font-raleway font-light text-red-200 text-[14px]">
                Разрешите доступ к микрофону в настройках браузера и попробуйте
                снова
              </p>
            </div>
            <button
              className="border border-[#A1F69E] text-[#A1F69E] text-[16px] px-6 py-3 rounded-lg mb-4"
              onClick={() => {
                setMicrophoneError(false);
                setRecordingComplete(false);
              }}
            >
              Попробовать снова
            </button>
          </div>
        ) : (
          <div className="flex justify-center items-center flex-col">
            <SimpleVoiceRecorder
              onRecordingStateChange={setIsRecording}
              onRecordingComplete={handleRecordingComplete}
              onResetRecording={handleResetRecording}
              onMicrophoneError={() => setMicrophoneError(true)}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Audio;
